module.exports = "<div class=\"text-center mt-{{top}} mb-{{bottom}}\">\n  <img src=\"assets/separator.png\" alt=\"Separateur Capsyco\" class=\"hidden-xs\" [class.adapt-width]=\"adaptWidth\">\n  <img src=\"assets/separator.png\" alt=\"Separateur Capsyco\" class=\"visible-xs adapt-width\">\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/enzo/Desktop/capsycofr-angular/src/app/components/separator/separator.component.html
// module id = ../../../../../src/app/components/separator/separator.component.html
// module chunks = main